export default "__VITE_ASSET__D1h7FrWG__"